import type { LanguageMode } from "../doc/languageMode.js";
import { CMD, type CommandId } from "./commandIds.js";

/** Rows under Language (order + optional separators before Style Configurator). */
export type LanguageMenuRow =
  | { kind: "item"; id: CommandId; mode: LanguageMode }
  | { kind: "separator" };

export const LANGUAGE_MENU_ROWS: readonly LanguageMenuRow[] = [
  { kind: "item", id: CMD.LANG_TEXT, mode: "text" },
  { kind: "separator" },
  { kind: "item", id: CMD.LANG_C, mode: "c" },
  { kind: "item", id: CMD.LANG_CPP, mode: "cpp" },
  { kind: "item", id: CMD.LANG_CS, mode: "cs" },
  { kind: "item", id: CMD.LANG_JAVA, mode: "java" },
  { kind: "separator" },
  { kind: "item", id: CMD.LANG_HTML, mode: "html" },
  { kind: "item", id: CMD.LANG_XML, mode: "xml" },
  { kind: "item", id: CMD.LANG_JSON, mode: "json" },
  { kind: "item", id: CMD.LANG_YAML, mode: "yaml" },
  { kind: "item", id: CMD.LANG_CSS, mode: "css" },
  { kind: "separator" },
  { kind: "item", id: CMD.LANG_JS, mode: "js" },
  { kind: "item", id: CMD.LANG_TS, mode: "ts" },
  { kind: "item", id: CMD.LANG_PHP, mode: "php" },
  { kind: "separator" },
  { kind: "item", id: CMD.LANG_PYTHON, mode: "python" },
  { kind: "item", id: CMD.LANG_RUBY, mode: "ruby" },
  { kind: "item", id: CMD.LANG_GO, mode: "go" },
  { kind: "item", id: CMD.LANG_RUST, mode: "rust" },
  { kind: "item", id: CMD.LANG_R, mode: "r" },
  { kind: "separator" },
  { kind: "item", id: CMD.LANG_LUA, mode: "lua" },
  { kind: "item", id: CMD.LANG_PERL, mode: "perl" },
  { kind: "item", id: CMD.LANG_BASH, mode: "bash" },
  { kind: "item", id: CMD.LANG_POWERSHELL, mode: "powershell" },
  { kind: "separator" },
  { kind: "item", id: CMD.LANG_SQL, mode: "sql" },
  { kind: "item", id: CMD.LANG_INI, mode: "ini" },
  { kind: "item", id: CMD.LANG_MAKEFILE, mode: "makefile" },
  { kind: "item", id: CMD.LANG_PROPS, mode: "props" },
  { kind: "separator" },
  { kind: "item", id: CMD.LANG_MD, mode: "md" },
  { kind: "item", id: CMD.LANG_TEX, mode: "tex" },
  { kind: "item", id: CMD.LANG_MAX, mode: "max" },
  { kind: "item", id: CMD.LANG_OEIS, mode: "oeis" },
  { kind: "item", id: CMD.LANG_CSV, mode: "csv" },
  { kind: "item", id: CMD.LANG_EXCEL, mode: "excel" },
  { kind: "item", id: CMD.LANG_PDF, mode: "pdf" },
  { kind: "item", id: CMD.LANG_DIFF, mode: "diff" },
  { kind: "item", id: CMD.LANG_LINUXOBJ, mode: "linuxobj" },
];
